const selectHasFetched = (state) =>
  state.areas.booking.isFetchingOptions && state.areas.booking.hasFetchedAppointments;

export default selectHasFetched;
